var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "scan_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "scan_svg__cls-3",
    d: "M10.3 10.41a.76.76 0 00-.77.77v23.09a.77.77 0 001.54 0V11.18a.77.77 0 00-.77-.77M18.32 10.41a.77.77 0 00-.77.77v23.09a.77.77 0 001.54 0V11.18a.76.76 0 00-.77-.77M14.31 10.41a.77.77 0 00-.77.77v16.54a.77.77 0 101.54 0V11.18a.76.76 0 00-.77-.77M22.34 10.41a.76.76 0 00-.77.77v16.54a.77.77 0 001.54 0V11.18a.77.77 0 00-.77-.77M30.36 10.41a.77.77 0 00-.77.77v16.54a.77.77 0 001.54 0V11.18a.76.76 0 00-.77-.77M34.38 10.41a.76.76 0 00-.77.77v23.09a.77.77 0 001.54 0V11.18a.77.77 0 00-.77-.77M26.35 10.41a.77.77 0 00-.77.77v23.09a.77.77 0 101.54 0V11.18a.76.76 0 00-.77-.77M5.79 32.34H4.44v7.12A1.54 1.54 0 006 41h7.1v-1.35H7.33a1.54 1.54 0 01-1.54-1.54zM13.1 5.79V4.44H6A1.54 1.54 0 004.44 6v7.1h1.35V7.33a1.54 1.54 0 011.54-1.54zm26.55 7.31H41V6a1.54 1.54 0 00-1.54-1.54h-7.12v1.33h5.77a1.54 1.54 0 011.54 1.54zM41 39.46v-7.12h-1.35v5.77a1.54 1.54 0 01-1.54 1.54h-5.77V41h7.12A1.54 1.54 0 0041 39.46"
  }))));
}

export default SvgScan;